!(function () {
  'use strict';

  const selectors = {
    scrollTo: '[data-scroll-to]',
    tooltip: '[data-tooltip]',
  };
  const attributes = {
    scrollTo: 'data-scroll-to',
    tooltipStopMouseenter: 'data-tooltip-stop-mouseenter',
  };

  customElements.get('scroll-to-element') ||
    customElements.define(
      'scroll-to-element',
      class extends HTMLElement {
        constructor() {
          super();
          this.scrollToButton = this.querySelector(selectors.scrollTo);
        }

        connectedCallback() {
          if (!this.scrollToButton) return;

          this.scrollToButton.addEventListener('click', () => {
            const target = document.querySelector(
              this.scrollToButton.getAttribute(attributes.scrollTo)
            );

            if (target && this.scrollToButton.tagName !== 'A') {
              this.scrollToElement(target);
            }
          });
        }

        scrollToElement(target) {
          // Only scroll — do not open the next accordion.
          // Opening details mid-scroll (especially with single="true")
          // shifts layout and makes the destination jump.
          const siblings = document.querySelectorAll(
            '.section-sidebar [data-scroll-spy]'
          );
          siblings.forEach((btn) => btn.classList.remove('is-selected'));
          this.scrollToButton.classList.add('is-selected');

          window.theme.scrollTo(target.getBoundingClientRect().top + 1);

          const tooltips = document.querySelectorAll(
            `${selectors.tooltip}:not([${attributes.tooltipStopMouseenter}])`
          );

          if (tooltips.length) {
            tooltips.forEach((tooltip) => {
              tooltip.setAttribute(attributes.tooltipStopMouseenter, '');
              setTimeout(() => {
                tooltip.removeAttribute(attributes.tooltipStopMouseenter);
              }, 1000);
            });
          }
        }
      }
    );
})();
